import { createAsyncThunk } from '@reduxjs/toolkit';
import { atsJobDetailsActions } from './atsJobDetailsReducer';
import { createApiAction } from '../shared/createApiAction';
import type { ApiRequestOptions, ThunkArgs } from '../shared/createApiAction';

// todo: need to update these, for now added some sample
const actionsConfig = {
  getCandidateList: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/',
    thunkName: 'candidateList',
    reducerName: 'candidateList',
    responseKey: 'data',
  },
  getStagesCount: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/count_by_stage',
    thunkName: 'getStagesCount',
    reducerName: 'getStagesCount',
    responseKey: 'data',
  },
  rejectCandidate: {
    method: 'post',
    endpoint: '/ats_applications/:applicationId/reject',
    thunkName: 'rejectCandidate',
  },
  bulkRejectCandidate: {
    method: 'post',
    endpoint: '/ats_applications/bulk_reject',
    thunkName: 'bulkRejectCandidate',
  },
  moveToStage: {
    method: 'post',
    endpoint: '/ats_applications/:applicationId/move',
    thunkName: 'moveToStage',
  },
  bulkMoveToStage: {
    method: 'post',
    endpoint: '/ats_applications/bulk_move',
    thunkName: 'bulkMoveToStage',
  },
  sendEmail: {
    method: 'post',
    endpoint: '/ats_applications/bulk_email',
    thunkName: 'sendEmail',
  },
  bulkSendEmail: {
    method: 'post',
    endpoint: '/ats_applications/bulk_email',
    thunkName: 'bulkSendEmail',
  },
  addToJob: {
    method: 'post',
    endpoint: '/ats_applications',
    thunkName: 'addToJob',
  },
  bulkAddToJob: {
    method: 'post',
    endpoint: '/ats_applications/bulk_create',
    thunkName: 'bulkAddToJob',
  },
  createContact: {
    method: 'post',
    endpoint: '/contacts',
    thunkName: 'createContact',
    reducerName: 'createContact',
  },
  importContact: {
    method: 'post',
    endpoint: '/ats_applications/bulk_create_from_contacts',
    thunkName: 'importContact',
    reducerName: 'importContact',
  },
  getKanbanList: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/filter_by_stage',
    thunkName: 'kanbanList',
    reducerName: 'kanbanList',
    responseKey: 'data',
  },
  getRejectedCount: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/count',
    thunkName: 'rejectedCount',
    reducerName: 'rejectedCount',
    responseKey: 'data',
  },
  getCurrentApplication: {
    method: 'get',
    endpoint: `/ats_applications/:applicationId`,
    thunkName: 'currentApplication',
    reducerName: 'currentApplication',
    responseKey: 'data',
  },
  getCurrentApplicationActivities: {
    method: 'get',
    endpoint: `/ats_applications/:applicationId/activities`,
    thunkName: 'currentApplicationActivities',
    reducerName: 'currentApplicationActivities',
  },
  getCurrentJobActivities: {
    method: 'get',
    endpoint: `/ats_jobs/:jobId/activities`,
    thunkName: 'currentJobActivities',
    reducerName: 'currentJobActivities',
  },
};

const apiAction = createApiAction({ actions: atsJobDetailsActions });

export const atsJobDetailsApiActions = (
  actionId,
  config: ApiRequestOptions = {}
) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for ats job create');

  const { endpoint, thunkName } = currentAction;

  if (isApi) {
    return (...args: ThunkArgs) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args: ThunkArgs) => {
    return createAsyncThunk(
      thunkName as string,
      // Pre-existing shape: a promise sits where a payload creator belongs.
      apiAction({ ...currentAction, endpoint }, config, args) as never
    );
  };
};
